import React from 'react';
import { IconAssets } from '@components/Icon/IconAssets';
import { IconType } from '@components/Icon/IconAssets';

type Props = {
  type: IconType;
  color?: string;
};

export const Icon: React.FC<Props> = ({ type, color }) => {
  const SelectedIcon = IconAssets[type];
  return <SelectedIcon color={color} />;
};
